import React from 'react';
import { useTranslation } from "react-i18next";

import bg1 from '@/assets/bg1.png';

export const HeroHeadline: React.FC = () => {
  const { t, i18n } = useTranslation();

  return (
    <div className="relative z-10 mx-auto w-full max-w-[min(85vw,26rem)] px-3 text-center sm:max-w-[min(88vw,34rem)] sm:px-4 md:max-w-[min(90vw,40rem)] lg:max-w-[min(92vw,44rem)]">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 z-0 rounded-[20px]"
        style={{
          backgroundImage: `url(${bg1})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center top',
          backgroundRepeat: 'no-repeat',
        }}
      />

      <div className="relative z-10 px-2 py-8 sm:px-4 sm:py-10">
        <div className="mb-6 inline-block">
          <span className="inline-block rounded-full bg-gradient-to-r from-[#8A43FF] to-[#00A9FF] px-[clamp(1.25rem,4vw,2.5rem)] py-1 text-base text-white shadow-lg shadow-[#5100FF]/20 sm:py-2 sm:text-lg">
            {t('hero-tagline')}
          </span>
        </div>

        <h1 className="mb-6 text-balance text-2xl font-bold text-white md:text-4xl">
          {t('hero-title')}
        </h1>

        <p className="mx-auto max-w-2xl text-pretty text-base leading-relaxed text-white/90 sm:text-lg">
          {t('hero-subtitle')}
        </p>
      </div>
    </div>
  );
};
